import {Routes} from "@angular/router";
import {WorkflowPartnerOneDowngradeSlaComponent} from "./workflow-partner-one-downgrade-sla.component";

export const workflowPartnerOneDowngradeSlaRouting: Routes = [
    { path: 'partner/downgrade-sla/:aid', component: WorkflowPartnerOneDowngradeSlaComponent, children: [
        { path: 'info', component: WorkflowPartnerOneDowngradeSlaComponent },
        { path: 'contact', component: WorkflowPartnerOneDowngradeSlaComponent },
        { path: 'address', component: WorkflowPartnerOneDowngradeSlaComponent },
        { path: 'payment', component: WorkflowPartnerOneDowngradeSlaComponent },
        { path: 'checkout', component: WorkflowPartnerOneDowngradeSlaComponent },
        { path: 'complete', component: WorkflowPartnerOneDowngradeSlaComponent },
        { path: '', redirectTo: 'info', pathMatch: 'full' },
    ]},
]
